<template>
  <div class="profile">
    <div class="profile-content" v-for='d in data'>
      <profile-cell class="content"
      v-bind:title="d.title"
      v-bind:items="d.items"
      >
      </profile-cell>
    </div>
  </div>
</template>

<script>

import ProfileCell from '@/components/ProfileCell'

export default {
  name: 'Profile',
  components: {
    ProfileCell
  },
  data() {
    return {
      text: "20 years old/ ui/ux engineer",
      data: [
        { title: '基本情報', items: [
          {category: 'ニックネーム: ', value: 'churabou'},
          {category: '年齢: ', value: '20 years old'},
          {category: '血液型: ', value: 'A型'},
          {category: '国籍: ', value: '日本'},
          {category: '出身地: ', value: '東京'}
          ]
        },
        { title: '学歴・職種・外見', items: [
          {category: '中学校: ', value: '公立中学'},
          {category: '高校: ', value: '国立大学附属高校'},
          {category: '大学: ', value: '私立大学経済学部'},
          {category: '職種: ', value: 'IT関連'},
          {category: '身長: ', value: '171cm'},
          {category: '体型: ', value: '痩せすぎ'},
          ]
        },
        { title: '恋愛・結婚について', items: [
          {category: '出会うまでの希望: ', value: '気が合えば会いたい'},
          {category: '初回デート費用: ', value: '相手と相談して決める'},
          ]
        },
        { title: '性格・趣味・生活', items: [
          {category: '性格: ', value: 'マイペース・親しみやすい・素直・優しい'},
          {category: 'タイプ: ', value: 'インドア'},
          {category: '趣味: ', value: '読書・ピアノ・犬の散歩・日向ぼっこ'},
          {category: '趣味にしたい: ', value: '競プロ・料理・アクロバット・フリースタイルフットボール'},
          {category: 'お酒: ', value: '飲まない'},
          {category: 'タバコ: ', value: '吸わない'},
          ]
        }
      ]
    }
  }
}

</script>

<style scoped>

div {
  margin-bottom: 100px;
}

.profile {
  /* background-color: red; */
  text-align: center;
}

/* profile classを指定したdivタグの子要素のpタグに適応 */
div.profile p {
  font-size: 18px;
  color: darkgray;
}

div.profile h3 {
  color: pink;
}

.content {
  /* background-color: red; */
}

</style>



// WEBPACK FOOTER //
// src/pages/Profile.vue